// Central config: single point of change for the portal data source.
// The remote endpoint currently serves stale content (image URLs return 403),
// so we bypass it and rely on the local /data.json shipped in /public.
// To re-enable the remote source once it is updated, set DATA_ENDPOINT back to
// "https://daffy-marble-tarsier-of-kindness.emerge.host".
export const DATA_ENDPOINT = "";
export const LOCAL_FALLBACK = "/data.json";
